import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { LeadsService } from 'src/app/_service/leads.service';
import { MiscService } from '../../_service/misc.service';
import { SharedService } from '../../_service/shared.service';
declare var $: any;
@Component({
  selector: 'app-ctoc-report',
  templateUrl: './ctoc-report.component.html',
  styleUrls: ['./ctoc-report.component.css']
})
export class CtocReportComponent implements OnInit {
  
  todayDate : Date = new Date();
  myrole:string;
  ctoc_report_loading:boolean=false;ctocReportLists = [];bds=[];bds_copy=[];bd:string;
  ctoc_report_loading_feedback:boolean=false;ctocReportListsFeedback = [];feedbackBds=[];feedbackBds_copy=[];feedbackbd:string;is_doctor_access='';treatCategory=[];treatCategory_copy=[];lead_category_filter='';start_date:string='';showFilterDate:string='';
  start_date_feedback:string='';showFilterDateFeedback:string='';
  callAtmentTotal:number=0;callConnectTotal:number=0;callAtmentTotalFeedbackUser:number=0;callConnectTotalFeedbackUser:number=0;
   
  @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
  @ViewChild('dateRangeStartFeedback', {static: false}) dateRangeStartFeedback: ElementRef;

  constructor(public miscapi:MiscService, private sharedapi:SharedService,private leadapi:LeadsService,) {
    this.sharedapi.getRole()
    .subscribe((item:string) => {this.myrole=item;});
    this.myrole = localStorage.getItem('role');
    this.is_doctor_access = localStorage.getItem('is_doctor_access');
   }

  ngOnInit(): void {
    if(this.myrole == '3'){
      this.getbds();
      this.gettocReportList();
    }else if(this.myrole == '4')
    {
      this.getFeedbackUsers();
      this.gettocReportListForFeedBack();
    }else{
      this.getbds();
      this.getFeedbackUsers();
      this.gettocReportList();
      this.gettocReportListForFeedBack();
    }
    this.getTreatmentCategory();
    
  }

  async gettocReportList()
  {
    this.showFilterDate = this.start_date;
    let qString = 'bd=' + this.bd +'&lead_category_filter='+this.lead_category_filter+'&date_range='+this.start_date;
    this.ctoc_report_loading=true;
    await this.miscapi.gettocReportData(qString).subscribe((data:any) => {
        this.ctoc_report_loading=false;
        if(data.status)
        {
          this.ctocReportLists = data.data;

          this.callAtmentTotal = data.data.reduce((total,item)=>{
            return total + item.total_no_of_call_attempts;
          },0);

          this.callConnectTotal = data.data.reduce((total,item)=>{
            return total + item.call_connected;
          },0);
        }else{
          this.sharedapi.presentToast('Something went wrong. Please try again.');
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  converttominfromsec(totalsec)
  {
    const minutes: number = Math.floor(totalsec / 60);
    const seconds: number = totalsec % 60;

    let loc_min = '';
    if(minutes > 0)
    {
      loc_min += minutes+ " Min " 
    }
    if(seconds > 0)
    {
      loc_min += seconds+ " Sec" 
    }

    if(loc_min)
    {
      return loc_min;
    } 
    else 
    {
      return 0;
    }
  }

  setSearchValue(type){
    if(type=='bds'){
        $("#bd_search").val('');
        $("#bd_search").focus();
        this.bds= this.bds_copy;
    } else if(type=='feedbackbds'){
      $("#feedbackbd_search").val('');
      $("#feedbackbd_search").focus();
      this.feedbackBds= this.feedbackBds_copy;
    } else if(type=='leadCategory'){
      $("#leadcategorySearch").val('');
      $("#leadcategorySearch").focus();
      this.treatCategory= this.treatCategory_copy;
  }
}

searchOnSelect(searchtText: string, type){
  if(type == 'bds'){
      this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
  } else if(type == 'feedbackbds'){
    this.feedbackBds = this.sharedapi.searchData(searchtText, this.feedbackBds_copy, "name");
  } else  if (type == 'leadCategory') {
    this.treatCategory = this.sharedapi.searchData(searchtText, this.treatCategory_copy, "name");
   }
}

async getbds(status=1)
{
    this.leadapi.getbds(status).subscribe((data:any) => {
        if(data.status)
        {
            this.bds = data.data;
            this.bds_copy = this.bds;
        }else{
            this.bds = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
}

async gettocReportListForFeedBack()
  {
    this.showFilterDateFeedback = this.start_date_feedback;
    let qString = 'bd=' + this.feedbackbd+'&date_range='+this.start_date_feedback;
    this.ctoc_report_loading_feedback=true;
    await this.miscapi.gettocReportDataForFeedback(qString).subscribe((data:any) => {
        this.ctoc_report_loading_feedback=false;
        if(data.status)
        {
          this.ctocReportListsFeedback = data.data;
          
          this.callAtmentTotalFeedbackUser = data.data.reduce((total,item)=>{
            return total + item.total_no_of_call_attempts;
          },0);

          this.callConnectTotalFeedbackUser = data.data.reduce((total,item)=>{
            return total + item.call_connected;
          },0);

        }else{
          this.sharedapi.presentToast('Something went wrong. Please try again.');
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  async getFeedbackUsers(status=1)
{
    this.leadapi.getFeedbackUsers(status).subscribe((data:any) => {
        if(data.status)
        {
            this.feedbackBds = data.data;
            this.feedbackBds_copy = this.feedbackBds;
        }else{
            this.feedbackBds = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
}

async getTreatmentCategory()
{
    await this.miscapi.getTreat_Category().subscribe((data:any) => {
        if(data.status)
        {
            this.treatCategory = data.data;
            this.treatCategory_copy = this.treatCategory;
        }else{
            this.treatCategory = [];
            this.sharedapi.presentToast(data.msg);
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
}

dateRangeChange(date1)
{
  if(date1.value)
  {
      this.start_date = date1.value;
  }
}

dateRangeChangeFeedback(date1)
{
  if(date1.value)
  {
      this.start_date_feedback = date1.value;
  }
}

}
